import { atom } from "recoil";
import { AppConfigType } from "types/config";

export const DEFAULT_CONFIG_STATE: Partial<AppConfigType> = {
  isLoadingConfig: true,
  admin: undefined,
  lang: undefined,
  menu: undefined,
  user: undefined,
};

export const configState = atom<Partial<AppConfigType>>({
  key: "configState",
  default: {
    ...DEFAULT_CONFIG_STATE,
  },
});